import React, {
    useState,
    useEffect,
 
} from "react"
import {   Tabs, Badge } from './ot'

const BaseListView1_6 = ({
    mt = 0,
    leading,
    style,
    children,
    className = "text-xs sm:text-sm",
    ...props
}, ref) => {
    

    return (
        <div
            style={style}
            {...props}
            className={`${className} mt-${mt || 0} leading-${leading || 1}`}
        >
            {children}
        </div>
    )
}

export default BaseListView1_6
